import React from "react";
import NavBar from "../Common/NavBar";

const seats = [
  { id: "conductor", label: "Conductor", status: "ok", x: 126, y: 146, w: 118, h: 126, type: "front" },
  { id: "copiloto", label: "Copiloto", status: "ok", x: 476, y: 146, w: 118, h: 126, type: "front" },
  { id: "litera1", label: "Litera 1", status: "warning", x: 92, y: 330, w: 168, h: 88, type: "rear" },
  { id: "litera2", label: "Litera 2", status: "ok", x: 276, y: 330, w: 168, h: 88, type: "rear" },
  { id: "litera3", label: "Litera 3", status: "ok", x: 460, y: 330, w: 168, h: 88, type: "rear" },
];

const statusMeta = {
  ok: { text: "Correcto", fill: "#193f2b", stroke: "#37d767", chip: "#28c832", glow: "rgba(40, 200, 50, 0.18)" },
  warning: { text: "Revision", fill: "#45330f", stroke: "#f8b719", chip: "#f8b719", glow: "rgba(248, 183, 25, 0.18)" },
  critical: { text: "Alerta", fill: "#4e171d", stroke: "#ff5b64", chip: "#db2329", glow: "rgba(219, 35, 41, 0.18)" },
};

function FrontSeat({ seat }) {
  const meta = statusMeta[seat.status];
  return (
    <g>
      <ellipse cx={seat.x + seat.w / 2} cy={seat.y + seat.h + 12} rx="58" ry="14" fill={meta.glow} />
      <rect x={seat.x + 12} y={seat.y} width={seat.w - 24} height="56" rx="24" fill={meta.fill} stroke={meta.stroke} strokeWidth="2.5" />
      <rect x={seat.x + 22} y={seat.y + 16} width={seat.w - 44} height="16" rx="8" fill="rgba(255,255,255,0.12)" />
      <rect x={seat.x} y={seat.y + 40} width={seat.w} height="78" rx="22" fill={meta.fill} stroke={meta.stroke} strokeWidth="2.5" />
      <rect x={seat.x + 12} y={seat.y + 58} width={seat.w - 24} height="24" rx="12" fill="rgba(255,255,255,0.1)" />
      <path d={`M ${seat.x + 22} ${seat.y + 118} L ${seat.x + 34} ${seat.y + 148} M ${seat.x + seat.w - 22} ${seat.y + 118} L ${seat.x + seat.w - 34} ${seat.y + 148}`} stroke="#6f89a3" strokeWidth="5" strokeLinecap="round" />
      <circle cx={seat.x + 20} cy={seat.y + 102} r="7" fill={meta.chip} />
      <text x={seat.x + seat.w / 2} y={seat.y + 104} textAnchor="middle" fill="#ffffff" fontSize="15" fontWeight="700">{seat.label}</text>
      <text x={seat.x + seat.w / 2} y={seat.y + 123} textAnchor="middle" fill="#dbeaf8" fontSize="12">{meta.text}</text>
    </g>
  );
}

function RearBunk({ seat }) {
  const meta = statusMeta[seat.status];
  return (
    <g>
      <ellipse cx={seat.x + seat.w / 2} cy={seat.y + seat.h + 10} rx="72" ry="12" fill={meta.glow} />
      <rect x={seat.x} y={seat.y + 18} width={seat.w} height={seat.h - 18} rx="20" fill={meta.fill} stroke={meta.stroke} strokeWidth="2.5" />
      <rect x={seat.x + 14} y={seat.y + 32} width={seat.w - 28} height="24" rx="12" fill="rgba(255,255,255,0.12)" />
      <rect x={seat.x + 18} y={seat.y + 12} width="56" height="20" rx="10" fill="rgba(255,255,255,0.18)" />
      <path d={`M ${seat.x + 18} ${seat.y + seat.h - 2} L ${seat.x + 18} ${seat.y + seat.h + 16} M ${seat.x + seat.w - 18} ${seat.y + seat.h - 2} L ${seat.x + seat.w - 18} ${seat.y + seat.h + 16}`} stroke="#6f89a3" strokeWidth="4" strokeLinecap="round" />
      <circle cx={seat.x + 20} cy={seat.y + seat.h - 18} r="7" fill={meta.chip} />
      <text x={seat.x + seat.w / 2} y={seat.y + 66} textAnchor="middle" fill="#ffffff" fontSize="15" fontWeight="700">{seat.label}</text>
      <text x={seat.x + seat.w / 2} y={seat.y + 84} textAnchor="middle" fill="#dbeaf8" fontSize="12">{meta.text}</text>
    </g>
  );
}

export function SvgTest() {
  return (
    <div className="svg-test-page">
      <style>{`
        * { box-sizing: border-box; }
        .svg-test-page {
          min-height: 100vh;
          background:
            radial-gradient(circle at top left, rgba(52, 152, 255, 0.14), transparent 30%),
            radial-gradient(circle at bottom right, rgba(13, 74, 135, 0.2), transparent 28%),
            linear-gradient(180deg, #06131f 0%, #081a2b 100%);
          color: #ffffff;
          padding: 88px 20px 24px;
          font-family: Arial, Helvetica, sans-serif;
        }
        .svg-test-wrap {
          width: 100%;
        }
        .svg-card {
          background: linear-gradient(145deg, rgba(16, 38, 59, 0.96), rgba(8, 24, 40, 0.98));
          border: 1px solid rgba(93, 140, 183, 0.32);
          border-radius: 18px;
          padding: 24px;
          box-shadow: inset 0 1px 0 rgba(255,255,255,0.05), 0 24px 48px rgba(0,0,0,0.24);
        }
        .heading {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          gap: 16px;
          margin-bottom: 18px;
        }
        .heading h1 {
          font-size: 26px;
          margin-bottom: 6px;
        }
        .heading p {
          font-size: 14px;
          color: #d7e7f6;
          max-width: 760px;
        }
        .tag {
          border: 1px solid rgba(84, 154, 255, 0.45);
          background: rgba(17, 71, 123, 0.38);
          color: #a8d6ff;
          padding: 9px 12px;
          border-radius: 999px;
          font-size: 12px;
          white-space: nowrap;
        }
        .layout {
          display: grid;
          grid-template-columns: minmax(0, 1fr) 280px;
          gap: 18px;
          align-items: start;
        }
        .visual-shell {
          border-radius: 18px;
          border: 1px solid rgba(255,255,255,0.08);
          background:
            linear-gradient(180deg, rgba(255,255,255,0.04), rgba(255,255,255,0.01)),
            rgba(4, 13, 22, 0.78);
          padding: 18px;
        }
        .visual-shell svg {
          width: 100%;
          height: auto;
          display: block;
        }
        .side-panel {
          display: grid;
          gap: 12px;
        }
        .legend-card,
        .status-card {
          border-radius: 14px;
          border: 1px solid rgba(255,255,255,0.08);
          background: rgba(4, 13, 22, 0.72);
          padding: 16px;
        }
        .legend-card h3,
        .status-card h3 {
          font-size: 14px;
          margin-bottom: 12px;
          text-transform: uppercase;
          letter-spacing: 0.04em;
        }
        .legend-item,
        .status-item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 10px;
          padding: 8px 0;
          font-size: 13px;
          color: #ffffff;
        }
        .legend-item + .legend-item,
        .status-item + .status-item {
          border-top: 1px solid rgba(255,255,255,0.06);
        }
        .dot {
          width: 12px;
          height: 12px;
          border-radius: 50%;
          display: inline-block;
          margin-right: 8px;
        }
        .dot.ok { background: #28c832; }
        .dot.warning { background: #f8b719; }
        .dot.critical { background: #db2329; }
        .pill {
          font-size: 11px;
          padding: 5px 9px;
          border-radius: 999px;
          border: 1px solid rgba(255,255,255,0.12);
        }
        .pill.ok { color: #9af0a8; background: rgba(40, 200, 50, 0.15); }
        .pill.warning { color: #ffd16a; background: rgba(248, 183, 25, 0.16); }
        .pill.critical { color: #ffb1b5; background: rgba(219, 35, 41, 0.16); }
        @media (max-width: 980px) {
          .layout {
            grid-template-columns: 1fr;
          }
          .heading {
            flex-direction: column;
          }
        }
      `}</style>

      <NavBar />

      <main className="svg-test-wrap">
        <section className="svg-card">
          <div className="heading">
            <div>
              <h1>Cabina SVG de prueba</h1>
              <p>Vista descartable para evaluar una cabina de camion mas realista: frente operativo, asientos delanteros, tablero, pasillo central y bloque posterior de literas.</p>
            </div>
            <span className="tag">Ruta temporal: /svg-test</span>
          </div>

          <div className="layout">
            <div className="visual-shell">
              <svg viewBox="0 0 720 500" role="img" aria-label="Simulacion de cabina de camion con asientos y estados">
                <defs>
                  <linearGradient id="shell" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor="#122c43" />
                    <stop offset="100%" stopColor="#07131e" />
                  </linearGradient>
                  <linearGradient id="glass" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor="#4ab0ff" stopOpacity="0.72" />
                    <stop offset="100%" stopColor="#0e3654" stopOpacity="0.24" />
                  </linearGradient>
                  <linearGradient id="dashboard" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor="#17324c" />
                    <stop offset="100%" stopColor="#0a1622" />
                  </linearGradient>
                  <linearGradient id="floor" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor="#18354d" stopOpacity="0.82" />
                    <stop offset="100%" stopColor="#091520" stopOpacity="1" />
                  </linearGradient>
                </defs>

                <path d="M88 48 L632 48 C663 48 688 73 688 104 L688 404 C688 435 663 460 632 460 L88 460 C57 460 32 435 32 404 L32 104 C32 73 57 48 88 48 Z" fill="url(#shell)" stroke="#2b577d" strokeWidth="2" />
                <path d="M144 76 L576 76 C606 76 628 96 632 122 L620 154 L100 154 L88 122 C92 96 114 76 144 76 Z" fill="#15344d" stroke="#2e6997" />
                <path d="M116 92 L332 92 L344 146 L98 146 L106 110 C109 99 116 92 116 92 Z" fill="url(#glass)" stroke="#8bd7ff" strokeOpacity="0.38" />
                <path d="M604 92 L388 92 L376 146 L622 146 L614 110 C611 99 604 92 604 92 Z" fill="url(#glass)" stroke="#8bd7ff" strokeOpacity="0.38" />
                <rect x="355" y="84" width="10" height="68" rx="5" fill="#b5d7ef" opacity="0.74" />

                <path d="M118 162 C172 146, 256 138, 360 138 C464 138, 548 146, 602 162 L574 238 C505 223, 434 214, 360 214 C286 214, 215 223, 146 238 Z" fill="url(#dashboard)" stroke="#2b5f88" />
                <circle cx="210" cy="194" r="28" fill="#0f2333" stroke="#3d7fb0" />
                <circle cx="210" cy="194" r="19" fill="#173b59" />
                <rect x="314" y="166" width="92" height="32" rx="12" fill="#1d4769" stroke="#4d8fc3" />
                <rect x="420" y="170" width="104" height="22" rx="11" fill="#142c42" stroke="#2f658f" />
                <text x="360" y="187" textAnchor="middle" fill="#d7efff" fontSize="13" fontWeight="700">Panel central</text>

                <path d="M84 250 C160 224, 560 224, 636 250 L652 420 C581 438, 139 438, 68 420 Z" fill="url(#floor)" stroke="#255274" />
                <path d="M300 228 L420 228 L454 428 L266 428 Z" fill="#0a1520" stroke="#244f72" />
                <rect x="320" y="236" width="80" height="156" rx="18" fill="#12283c" stroke="#366d98" />
                <rect x="336" y="252" width="48" height="96" rx="14" fill="#0d1f2e" stroke="#254a69" />
                <text x="360" y="406" textAnchor="middle" fill="#9ec7e8" fontSize="12" fontWeight="700">Pasillo central</text>

                <path d="M62 168 L116 168 L106 352 L60 366 Z" fill="#0b1a28" stroke="#264e71" />
                <path d="M658 168 L604 168 L614 352 L660 366 Z" fill="#0b1a28" stroke="#264e71" />
                <text x="80" y="386" fill="#7eaad0" fontSize="11">Puerta izq.</text>
                <text x="604" y="386" fill="#7eaad0" fontSize="11">Puerta der.</text>

                <rect x="70" y="306" width="580" height="128" rx="26" fill="#0e2131" stroke="#2a5b81" />
                <path d="M262 306 L262 434 M458 306 L458 434" stroke="#295a80" strokeWidth="2" strokeDasharray="5 7" />
                <text x="360" y="292" textAnchor="middle" fill="#97c4e8" fontSize="12" fontWeight="700">Zona posterior de descanso</text>

                {seats.map((seat) => (seat.type === "front" ? <FrontSeat key={seat.id} seat={seat} /> : <RearBunk key={seat.id} seat={seat} />))}

                <text x="360" y="64" textAnchor="middle" fill="#c6e6ff" fontSize="13" fontWeight="700">Frente de cabina / parabrisas</text>
              </svg>
            </div>

            <aside className="side-panel">
              <div className="legend-card">
                <h3>Leyenda</h3>
                <div className="legend-item"><span><span className="dot ok" />Correcto</span><span className="pill ok">OK</span></div>
                <div className="legend-item"><span><span className="dot warning" />Revision</span><span className="pill warning">WARN</span></div>
                <div className="legend-item"><span><span className="dot critical" />Alerta</span><span className="pill critical">CRIT</span></div>
              </div>

              <div className="status-card">
                <h3>Estado actual</h3>
                {seats.map((seat) => (
                  <div className="status-item" key={seat.id}>
                    <span>{seat.label}</span>
                    <span className={`pill ${seat.status}`}>{statusMeta[seat.status].text}</span>
                  </div>
                ))}
              </div>
            </aside>
          </div>
        </section>
      </main>
    </div>
  );
}
